import Cookies from "js-cookie";

import { jjLogger } from "utils/logUtils";
import FacebookConversionRepository from "repositories/FacebookConversionRepository";

const enqueueEvent = (currentUser, event) => {
  const eventWithTime = {
    ...event,
    event_time: Math.round(Date.now() / 1000),
  };
  window.fbCapiQueue.push({ currentUser, event: eventWithTime });
  if (typeof window.fbCapiDrainQueue === "function") {
    window.fbCapiDrainQueue();
  }
};

export const setUpFacebookQueue = () => {
  if (window.fbCapiQueueInitialized) return;
  window.fbCapiQueueInitialized = true;

  window.fbCapiQueue = window.fbCapiQueue || [];

  window.fbCapiDrainQueue = () => {
    if (!window.clientParamBuilder || !window.fbCapiQueue.length) return;

    const queue = window.fbCapiQueue.splice(0);
    jjLogger.log(`conversion.js: draining ${queue.length} queued CAPI event(s)`);

    queue.forEach(({ currentUser, event }) => {
      try {
        FacebookConversionRepository.post(currentUser, event);
      } catch (e) {
        jjLogger.logError("conversion.js: fbCapiDrainQueue error", e);
      }
    });
  };

  window.fbCapiDrainQueue();

  const MAX_POLL_ITERATIONS = 25;
  let pollIterations = 0;
  const pollInterval = setInterval(() => {
    pollIterations += 1;
    if (!window.clientParamBuilder) {
      if (pollIterations >= MAX_POLL_ITERATIONS) {
        jjLogger.logError("conversion.js: clientParamBuilder failed to load after timeout");
        clearInterval(pollInterval);
      }
      return;
    }
    clearInterval(pollInterval);
    window.fbCapiDrainQueue();
  }, 200);
};

export const storeTestEventCode = () => {
  jjLogger.log("conversion.js: storeTestEventCode()");
  const params = new URL(window.location.href).searchParams;

  if (!params.has("test_event_code")) return;

  const in30min = 1 / 48;
  Cookies.set("test_event_code", params.get("test_event_code"), { expires: in30min });
};

export const trackCompleteRegistration = (currentUser, url) => {
  enqueueEvent(currentUser, {
    event_name: "CompleteRegistration",
    event_source_url: url,
  });
};

export const trackPageView = (currentUser) => {
  enqueueEvent(currentUser, {
    event_name: "PageView",
    event_source_url: window.location.href,
  });
};

export const trackInitiateCheckout = (currentUser) => {
  enqueueEvent(currentUser, {
    event_name: "InitiateCheckout",
    event_source_url: window.location.href,
    custom_data: {
      currency: "USD",
    },
  });
};

export const trackPurchase = (currentUser, offer) => {
  enqueueEvent(currentUser, {
    event_name: "Purchase",
    event_source_url: window.location.href,
    custom_data: {
      value: parseFloat(offer.price),
      currency: offer.currency,
    },
  });
};

export const trackViewContent = (currentUser, customData) => {
  enqueueEvent(currentUser, {
    event_name: "ViewContent",
    event_source_url: window.location.href,
    custom_data: customData,
  });
};
